export const EQUAL_EMPLOYMENT_PDF =
  'https://www.eeoc.gov/sites/default/files/2023-06/22-088_EEOC_KnowYourRights6.12ScreenRdr.pdf';
